module.exports = __webpack_public_path__ + "static/media/Workday.bd8a4fcc.svg";